import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const promociones = {
	state: {
		promociones : ''
	},
	getters: {
		getPromociones : state => state.promociones
	},
	actions: {
		requestPromociones : ({commit},) => {
			return new Promise((resolve, reject) => {
				axios.get(`api/promociones`)
				.then(response => {
					commit('setPromociones', response.data);
					resolve(true);
				})
				.catch(error => reject(error));
			});
		},
		requestPromocion : ({commit}, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/promocion/${slug}`)
				.then(response => {
					(!!response.data.titulo) ? resolve(response.data) : reject(false);
				})
				.catch(error => reject(error));

			});
		},
	},
	mutations: {
		setPromociones : (state, promociones) => {
			state.promociones = promociones;
		}
	}
}

export default promociones;



// WEBPACK FOOTER //
// ./src/store/promociones.js